export interface Health {
  status: 'ok';
}

export type ProbeResult = 'ok' | 'failed';

export interface Readiness {
  status: 'ready' | 'not_ready';
  checks: { postgres: ProbeResult; redis: ProbeResult };
}

export type LiveState = 'up' | 'down';
export type ReadinessState = 'ready' | 'not_ready' | 'unreachable';
export type CheckState = ProbeResult | 'unknown';

export interface ApiStatus {
  live: LiveState;
  readiness: ReadinessState;
  checks: { postgres: CheckState; redis: CheckState };
  checkedAt: string;
}

/** Folds the two probes into one view; a rejected probe means the API itself is unreachable. */
export function toApiStatus(
  health: PromiseSettledResult<Health>,
  readiness: PromiseSettledResult<Readiness>,
  checkedAt: Date,
): ApiStatus {
  const live: LiveState = health.status === 'fulfilled' ? 'up' : 'down';
  if (readiness.status !== 'fulfilled') {
    return {
      live,
      readiness: 'unreachable',
      checks: { postgres: 'unknown', redis: 'unknown' },
      checkedAt: checkedAt.toISOString(),
    };
  }
  return {
    live,
    readiness: readiness.value.status,
    checks: readiness.value.checks,
    checkedAt: checkedAt.toISOString(),
  };
}
